import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { AvatarModule } from 'primeng/avatar';
import { BadgeModule } from 'primeng/badge';
import { TabViewModule } from 'primeng/tabview';
import { catchError, throwError } from 'rxjs';
import { HttpResponse } from '../../../model/HttpResponse';
import { Modalidad } from '../../../model/Modalidad';
import { QueryOptionDto } from '../../../model/QueryOptionDto';
import { AcademyAdministratorOperation } from '../../../model/administrator/AcademyAdministratorOperation';
import { AcademyAdministratorType } from '../../../model/administrator/AcademyAdministratorType';
import { AdministratorEntity } from '../../../model/administrator/AdministratorEntity';
import { Category } from '../../../model/competitions/Category';
import { Competition } from '../../../model/competitions/Competition';
import { Event } from '../../../model/competitions/Event';
import { CategoryLevel } from '../../../model/competitions/Level';
import { CompetitionService } from '../../../services/competition.service';
import { LoadingService } from '../../../services/loading.service';
import { PageHeaderComponent } from "../../shared/page-header/page-header.component";
import { CompetitionsTableComponent } from '../competitions-table/competitions-table.component';
@Component({
    selector: 'app-competitions',
    standalone: true,
    providers: [MessageService],
    templateUrl: './competitions.component.html',
    styleUrl: './competitions.component.scss',
    imports: [
        TabViewModule,
        BadgeModule,
        AvatarModule,
        CompetitionsTableComponent,
        CommonModule,
        PageHeaderComponent
    ]
})
export class CompetitionsComponent implements OnInit {
  modalitiesTabs = [
    {
      label: 'Artístico',
      value: Modalidad.ARTISTICO,
    },
    {
      label: 'Carreras',
      value: Modalidad.CARRERAS,
    },
    {
      label: 'Hockey',
      value: Modalidad.HOCKEY,
    },
    {
      label: 'Skateboarding',
      value: Modalidad.SKATEBOARDING,
    },
  ];
  modalitieTabIndex: number = 0;
  modalitieSelected: Modalidad = Modalidad.ARTISTICO;

  competitions: Competition[] = [];
  showCompetitions: boolean = false;

  levels: CategoryLevel[] = [];
  categories: Category[] = [];
  events: Event[] = [];
  constructor(
    private competitionService: CompetitionService,
    private loadingService: LoadingService,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.onModalitieTabChange({ index: this.modalitieTabIndex });
    this.getLevels();
  }

  onModalitieTabChange(event: any) {
    this.modalitieSelected = this.modalitiesTabs[event.index].value;
    this.getCategories();
    this.getEvents();
  }

  getPublishedCompetitions() {
    this.loadingService.showLoading();
    const options: QueryOptionDto = {
      options: {
        conditionals: [
          {
            conditionalConnector: 'AND',
            logicOperator: '=',
            evaluatedProperty: 'modality',
            parameterName: '@ModalidadSelected',
            parameterValue: this.modalitieSelected,
          },
        ],
      },
    };

    const entity: AdministratorEntity = {
      type: AcademyAdministratorType.COMPETIIONS,
      operation: AcademyAdministratorOperation.SELECT,
      payload: options,
    };

    this.competitionService
      .sendRequest(entity)
      .pipe(catchError(this.handleError.bind(this)))
      .subscribe((response: HttpResponse) => {
        if (response.code === 200 && response.response) {
          this.competitions = response.response as Competition[];
          this.showCompetitions = true;
        } else {
          this.messageService.add({
            severity: 'info',
            summary: 'Sin evento',
            detail: 'No se encontraron eventos para la modalidad seleccionada',
            life: 5000,
          });
        }
        this.loadingService.hideLoading();
      });
  }

  getLevels() {
    this.loadingService.showLoading();
    const entity: AdministratorEntity = {
      type: AcademyAdministratorType.LEVELS,
      operation: AcademyAdministratorOperation.SELECT,
      payload: null,
    };

    this.competitionService
      .sendRequest(entity)
      .pipe(catchError(this.handleError.bind(this)))
      .subscribe((response: HttpResponse) => {
        if (response.code === 200 && response.response) {
          this.levels = response.response as CategoryLevel[];
        } else {
          this.messageService.add({
            severity: 'info',
            summary: 'Sin niveles',
            detail: 'No se encontraron niveles para la modalidad seleccionada',
            life: 5000,
          });
        }
        this.getCategories();
      });
  }

  getCategories() {
    this.loadingService.showLoading();
    const entity: AdministratorEntity = {
      type: AcademyAdministratorType.CATEGORIES,
      operation: AcademyAdministratorOperation.SELECT,
      payload: {
        options: {
          conditionals: [
            {
              conditionalConnector: 'AND',
              logicOperator: '=',
              evaluatedProperty: 'modality',
              parameterName: '@ModalidadSelected',
              parameterValue: this.modalitieSelected,
            },
          ],
        },
      },
    };

    this.competitionService
      .sendRequest(entity)
      .pipe(catchError(this.handleError.bind(this)))
      .subscribe((response: HttpResponse) => {
        if (response.code === 200 && response.response) {
          this.categories = response.response as Category[];
          this.getPublishedCompetitions();
        } else {
          this.messageService.add({
            severity: 'info',
            summary: 'Sin categorías',
            detail:
              'No se encontraron categorías para la modalidad seleccionada',
            life: 5000,
          });
        }
      });
  }

  getEvents() {
    // For now, we'll provide mock events for ARTISTICO modality
    // In a real implementation, this would call a backend service
    if (this.modalitieSelected === Modalidad.ARTISTICO) {
      this.events = [
        {
          id: '439466e6-8ab9-4ba2-9f46-0d07e570a93b',
          name: 'Rutina Libre',
          description: 'Evento de rutina libre para patinaje artístico',
          modality: Modalidad.ARTISTICO,
          isActive: true
        },
        {
          id: '2abcedf9-7713-4f5f-bdc3-b8e7692ac0d0',
          name: 'Rutina Obligatoria',
          description: 'Evento de rutina obligatoria para patinaje artístico',
          modality: Modalidad.ARTISTICO,
          isActive: true
        },
        {
          id: '3cd123e4-5678-9abc-def0-123456789abc',
          name: 'Saltos',
          description: 'Evento de saltos para patinaje artístico',
          modality: Modalidad.ARTISTICO,
          isActive: true
        }
      ];
    } else {
      this.events = [];
    }
  }

  handleError(error: HttpErrorResponse) {
    this.loadingService.hideLoading();
    if (error.status === 422) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Sin resultados',
        detail: 'No se encontraron resultados para la búsqueda realizada',
        life: 5000,
      });
    } else if (error.status === 0) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail:
          'No se pudo establecer conexión con el servidor, por favor inténtalo nuevamente',
        life: 5000,
      });
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: error.message,
        life: 5000,
      });
    }
    // Return an observable with a user-facing error message.
    return throwError(
      () => new Error('Something bad happened; please try again later.')
    );
  }
}
